// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

/**
 * Added v8 — see `ChannelModifier.schema_version`.
 *
 * What a precondition does while its channel has not yet reported the state
 * it reads (for example in the first poll after the channel connects).
 *   `ASSUME_MET` (0)     — treat the condition as holding.
 *   `ASSUME_NOT_MET` (1) — treat it as failing, so the modifier does not act.
 * Values are APPEND-ONLY.
 */
export enum PreconditionUnknown {
  ASSUME_MET = 0,
  ASSUME_NOT_MET = 1,
}
